// extracted by mini-css-extract-plugin
export default {"newsfeed":"pL-z"};